import { createContext, useContext } from 'react';
import type { NoteFragmentType } from '@/components/Note';

export type ModalState = 'idle' | 'adding' | 'editing';

interface ContextValue {
  modalState: ModalState;
  openNoteModal({
    companyId,
    uniqueSymbol,
    note,
  }: {
    companyId: string;
    uniqueSymbol: string;
    note?: NoteFragmentType;
  });
  closeNoteModal: () => void;
}

export const CompanyNoteModalContext = createContext<ContextValue>({
  modalState: 'idle',
  openNoteModal: () => null,
  closeNoteModal: () => null,
});

export const useCompanyNoteModal = () => {
  const context = useContext(CompanyNoteModalContext);
  if (typeof context === 'undefined') {
    throw new Error(
      'useCompanyNoteModal: Attempting to access undefined context, possibly outside of `CompanyNoteModalProvider`'
    );
  }
  return context;
};
